import React from 'react';
import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F5F8FB] text-[#141B22] font-sans w-full overflow-x-hidden">
      <Header />
      <main className="flex-1 w-full max-w-[68ch] min-w-0 mx-auto px-4 py-8 sm:py-12">
        {children}
      </main>
      <Footer />
    </div>
  );
}
